



















import { Component, Vue, Prop } from "vue-property-decorator"
import { EnergySource } from "../models/energy-source"

@Component
export default class OverviewElement extends Vue {
  @Prop() protected element: EnergySource

  protected determinePriceIncrease(element) {
    if (element.price > element.oldPrice) {
      return 1
    } else if (element.price < element.oldPrice) {
      return 0
    } else {
      return null
    }
  }

  protected determineUnitIncrease(element) {
    if (element.unitCap > element.oldUnits) {
      return 1
    } else if (element.unitCap < element.oldUnits) {
      return 0
    } else {
      return null
    }
  }
}
